import { useCallback, useEffect } from "react";
import clsx from "clsx";
import useIsMobile from "@/common/hook/useIsMobile";
import addNoScroll from "@/utils/addNoScroll";
import useOutsideClick from "@/common/hook/useOutsideClick";
import { mutate } from "swr";
import styles from "./index.module.css";

const DropdownMenu = ({ title, children, isOpen, setOpen, containerRef, className = "button-icon", badge = 0 }) => {
  const isMobile = useIsMobile();
  const ref = useOutsideClick(isOpen && (() => setOpen(false)));

  // REMOVE NO SCROLL CLASS WHEN UNLOAD COMPONENT
  useEffect(() => (isMobile ? () => addNoScroll(false) : undefined), [isMobile]);

  const handleToggle = useCallback(() => {
    // @TODO: Open chats only if isOpen the toggle
    mutate("/chats");

    setOpen((prev) => {
      if (isMobile) addNoScroll(!prev);
      return !prev;
    });
  }, [isMobile, setOpen]);

  return (
    <div className="relative" ref={ref} onClick={handleToggle} role="presentation">
      {badge > 0 && (
        <div
          type="button"
          className="absolute top-[-10px] right-[-5px] h-5 cursor-pointer select-none rounded-full bg-blue px-2 text-center text-sm font-semibold leading-5 text-white"
        >
          {badge}
        </div>
      )}
      <div className={clsx(`inline-flex`, className, isOpen && "border-blue text-blue")}>{title}</div>
      <div
        ref={containerRef}
        className={isOpen ? styles.dropdownContainer : "hidden"}
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        {children}
      </div>
    </div>
  );
};

export default DropdownMenu;
